module.exports = __webpack_public_path__ + "static/media/others (2).542d5058.jpg";